import { useCallback, useState } from "react";
import { getStudents, getFilteredStudents } from "../../../../services/StudentService";
import { handleApiError } from "../../../../utils/errorHandler"; // adjust path

const INITIAL_FILTERS = {
  name: "",
  idNumber: "",
  programId: "",
};

export const useStudents = () => {
  const [students, setStudents] = useState([]);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [isStudentLoading, setStudentLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  /* ================= FETCH ALL ================= */
  const fetchStudents = useCallback(async (pageNo = 1) => {
    setStudentLoading(true);
    setIsSearching(false);
    setStudents([]);

    try {
      const res = await getStudents(pageNo);
      if (res.status === 200) {
        setStudents(res.data.data);
        setLastPage(res.data.last_page);
        setPage(pageNo);
      }
    } catch (error) {
      handleApiError(error); // ✅ display API errors
    } finally {
      setStudentLoading(false);
    }
  }, []);

  /* ================= SEARCH ================= */
  const searchStudents = useCallback(async (pageNo = 1) => {
    setStudentLoading(true);
    setIsSearching(true);
    setStudents([]);

    try {
      const res = await getFilteredStudents(
        filters.name,
        filters.idNumber,
        filters.programId,
        pageNo
      );

      if (res.status === 200) {
        setStudents(res.data.data);
        setLastPage(res.data.last_page);
        setPage(pageNo);
      }
    } catch (error) {
      handleApiError(error); // ✅ display API errors
    } finally {
      setStudentLoading(false);
    }
  }, [filters]);

  /* ================= RESET ================= */
  const resetStudents = useCallback(() => {
    setFilters(INITIAL_FILTERS);
    fetchStudents(1);
  }, [fetchStudents]);

  /* ================= PAGINATION ================= */
  const handlePageChange = useCallback(
    (pageNo) => {
      isSearching ? searchStudents(pageNo) : fetchStudents(pageNo);
    },
    [isSearching, searchStudents, fetchStudents]
  );

  return {
    students,
    setStudents,
    filters,
    setFilters,
    page,
    lastPage,
    isStudentLoading,
    isSearching,
    fetchStudents,
    searchStudents,
    resetStudents,
    handlePageChange,
  };
};
